// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
// import { version } from "process";
export const isApp: boolean = false;
//export const urlSandboxSantander = "https://api.kabik.mx/Pagos/WSSantander.php/";
export const environment = {
  production: false,
  apiUrl: 'https://api.integradora.net/',
  apiUrlTest: 'http://192.168.1.82:8080/api/',
  empresaId: 5,
  apiImage: 'https://storagemultimedia.net/imagenes_pagina/',
  version: '1.0.14',
};
